import React, { Component } from "react";
import PropTypes from "prop-types";
import S from "../../../styles/components";
import TranscriptContainer from "./TranscriptContainer";
import Search from "./Search";
import connectToMedia from "../../Media/connectToMedia";

const mapStateToProps = (state) => ({ ...state.media });

class Index extends React.PureComponent {
  render() {
    const { readyState, transcript, isChatTextMedia } = this.props;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: "0",
        }}
      >
        <Search transcript={transcript} />
        <TranscriptContainer {...this.props} transcript={transcript} />
      </div>
    );
  }
}

export default connectToMedia()(Index);
